import { render, staticRenderFns } from "./HomeTopSellingItems.vue?vue&type=template&id=1fa37a5a&scoped=true"
import script from "./HomeTopSellingItems.vue?vue&type=script&lang=js"
export * from "./HomeTopSellingItems.vue?vue&type=script&lang=js"
import style0 from "./HomeTopSellingItems.vue?vue&type=style&index=0&id=1fa37a5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa37a5a",
  null
  
)

export default component.exports